import iconArrowRight from '../img/icon-arrow-right-black.png';
import PropTypes from 'prop-types';
import React from 'react';


export default class Pagination extends React.Component{
  render(){
    const {currentPage, totalPage, handlePagination} = this.props;
    let tempArray = [];

    if(totalPage >= 5){
      if(currentPage > 2 && currentPage < totalPage - 1){
        for(let i = currentPage - 2; i < currentPage + 3; i++){
          tempArray.push(i);
        }
      }
      else if(currentPage < 3){
        for(let i = 1; i < 6; i++){
          tempArray.push(i);
        }
      }
      else{
        for(let i = totalPage - 4; i < totalPage + 1; i++){
          tempArray.push(i);
        }
      }
    }
    else{
      for(let i = 1; i < totalPage + 1; i++){
        tempArray.push(i);
      }
    }

    return (
      <nav className="pagination-container" aria-label="Pagination">
        <ul className="pagination">
          <li className={`page-item ${currentPage === 1 ? 'disabled-button' : ''}`}>
            <button type="button"
                    className="page-link arrow-button"
                    aria-label="Previous page"
                    disabled={currentPage === 1}
                    onClick={() => handlePagination(currentPage - 1)}>
              <img alt="" className="button__icon button__left" src={iconArrowRight}/>
            </button>
          </li>
          {tempArray.map(page => {
            page = Math.round(page);
            if(page === currentPage){
              return (
                <li className="page-item active" key={page}>
                  <button type="button"
                          className="page-link"
                          aria-label={`Page ${page}, current page`}
                          aria-current="page"
                          disabled>
                    {page}
                  </button>
                </li>
              );
            }
            return (
              <li className="page-item" key={page}>
                <button type="button"
                        className="page-link"
                        aria-label={`Page ${page}`}
                        onClick={() => handlePagination(page)}>
                  {page}
                </button>
              </li>
            );
          })}
          <li className={`page-item ${currentPage >= totalPage ? 'disabled-button' : ''}`}>
            <button type="button"
                    className="page-link arrow-button"
                    aria-label="Next page"
                    disabled={currentPage >= totalPage}
                    onClick={() => handlePagination(currentPage + 1)}>
              <img alt="" className="button__icon" src={iconArrowRight}/>
            </button>
          </li>
        </ul>
      </nav>
    );
  }
}


Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPage: PropTypes.number.isRequired,
  handlePagination: PropTypes.func,
};
